import { Button } from "@shopify/polaris";
import React, { useCallback, useRef, useState } from "react";

export default function LoadingButton(props) {
  const { label, disabled, onClick } = props;

  const [loading, setLoading] = useState(false);

  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  const handleClick = useCallback(async () => {
    setLoading(true);
    await onClickRef.current();
    setLoading(false);
  }, []);

  return (
    <Button disabled={disabled} loading={loading} onClick={handleClick}>
      {label}
    </Button>
  );
}
